import {regionIsoEnum} from "@/core/constants/regionIsoEnum";

export function regionRelativeUrl(path, isAsset = false) {
    const regionPathConfig = process.env.MIX_REGION_PATH;
    const ASSETS_PATH = '/assets';
    let regionPath = isAsset ? (regionPathConfig || regionIsoEnum.GERMANY) : regionPathConfig;

    if (!regionPath || !path) {
        return path;
    }

    if(isAsset){
        if (regionPath === regionIsoEnum.GERMANY) {
            regionPath = ASSETS_PATH;
        } else {
            regionPath += ASSETS_PATH;
        }
    }

    if (path.startsWith("http") || path.startsWith("www")) {
        return path;
    }

    if (!path.startsWith("/")) {
        path = "/" + path;
    }

    if (regionPath === ASSETS_PATH) {
        return `${regionPath}${path}`;
    }

    if(!path.startsWith(`/${regionPath}`)){
        return `/${regionPath}${path}`;
    }

    return path;
}

export function pathWithoutRegion(path) {
    if(typeof settings === "undefined"){
        return path;
    }

    const redirectRegionPaths = settings.redirectRegionPaths;

    if(!redirectRegionPaths){
        return path;
    }

    let tmpPath = path;
    let boolHadSlash = false;

    if (tmpPath.startsWith("/")) {
        boolHadSlash = true;
        tmpPath = tmpPath.substring(1)
    }

    for (const region of redirectRegionPaths) {
        const math = `${region}/`
        if (tmpPath.startsWith(math)) {
            tmpPath = tmpPath.substring(math.length)
            break;
        }
    }

    return boolHadSlash ? `/${tmpPath}` : tmpPath;
}
